import { useState } from 'react';
import type { CookieConsentChoice } from '@gwc/shared';
import { useAuth } from '../auth/AuthProvider';

export function CookieConsentBanner() {
  const { cookieConsentRequired, saveCookieConsent } = useAuth();
  const [saving, setSaving] = useState(false);

  if (!cookieConsentRequired) return null;

  async function choose(choice: CookieConsentChoice) {
    setSaving(true);
    try {
      await saveCookieConsent(choice);
    } finally {
      setSaving(false);
    }
  }

  return (
    <div
      role="dialog"
      aria-labelledby="cookie-consent-title"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-ink-800 bg-ink-950/95 px-4 py-4 shadow-lg backdrop-blur sm:px-6"
    >
      <div className="mx-auto flex max-w-6xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="max-w-2xl">
          <p id="cookie-consent-title" className="text-sm font-medium text-cream-100">
            Cookies &amp; privacy
          </p>
          <p className="mt-1 text-sm text-cream-300/70">
            We use essential cookies to keep you signed in. With your permission we also use cookies
            to remember your preferences on this device. Your choice is saved to your account for
            this browser only.
          </p>
        </div>
        <div className="flex shrink-0 flex-wrap gap-2">
          <button
            type="button"
            disabled={saving}
            onClick={() => void choose('essential')}
            className="btn-ghost px-4 py-2 text-sm"
          >
            Essential only
          </button>
          <button
            type="button"
            disabled={saving}
            onClick={() => void choose('accepted')}
            className="btn-primary px-4 py-2 text-sm"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
}
